// src/App.tsx
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Head from "./components/Head";
import ScrollToTop from "./components/ScrollToTop";

// Main pages
import Index from "./pages/Index";
import Keramika from "./pages/Keramika";
import Kamen from "./pages/Kamen";
import Pulti from "./pages/Pulti";
import Storitve from "./pages/Storitve";
import NasvetiBlog from "./pages/NasvetiBlog";
import Kontakt from "./pages/Kontakt";
import NotFound from "./pages/NotFound";
import BlogPostTemplate from "./components/BlogPostTemplate";

// Legal pages
import Cookies from "./pages/Cookies";
import GDPR from "./pages/GDPR";

// Keramika subpages
import VidezLesa from "./pages/keramika/VidezLesa";
import VidezMarmorja from "./pages/keramika/VidezMarmorja";
import VidezBetonaKamna from "./pages/keramika/VidezBetonaKamna";
import Dekor from "./pages/keramika/Dekor";
import VelikoformatnaKeramika from "./pages/keramika/VelikoformatnaKeramika";

// Kamen subpages
import TehnicniKamen from "./pages/kamen/TehnicniKamen";
import Granit from "./pages/kamen/Granit";
import OkenskePolice from "./pages/kamen/OkenskePolice";
import Stopnice from "./pages/kamen/Stopnice";
import Tlaki from "./pages/kamen/Tlaki";

// Pulti subpages
import AbkStonePulti from "./pages/pulti/AbkStonePulti";
import GranitPulti from "./pages/pulti/GranitPulti";
import QuartzPulti from "./pages/pulti/QuartzPulti";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Head /> 
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop /> 
        <Routes>
          {/* Main pages */}
          <Route path="/" element={<Index />} />
          <Route path="/keramika" element={<Keramika />} />
          <Route path="/kamen" element={<Kamen />} />
          <Route path="/pulti" element={<Pulti />} />
          <Route path="/storitve" element={<Storitve />} />
          <Route path="/nasveti-blog" element={<NasvetiBlog />} />
          <Route path="/nasveti-blog/:id" element={<BlogPostTemplate />} />
          <Route path="/kontakt" element={<Kontakt />} />
          
          {/* Legal pages */}
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/gdpr" element={<GDPR />} />
          
          {/* Keramika subpages */}
          <Route path="/keramika/videz-lesa" element={<VidezLesa />} />
          <Route path="/keramika/videz-marmorja" element={<VidezMarmorja />} />
          <Route path="/keramika/videz-betona-kamna" element={<VidezBetonaKamna />} />
          <Route path="/keramika/dekor" element={<Dekor />} />
          <Route path="/keramika/velikoformatna-keramika" element={<VelikoformatnaKeramika />} />
          
          {/* Kamen subpages */}
          <Route path="/kamen/tehnicni-kamen" element={<TehnicniKamen />} />
          <Route path="/kamen/granit" element={<Granit />} />
          <Route path="/kamen/okenske-police" element={<OkenskePolice />} />
          <Route path="/kamen/stopnice" element={<Stopnice />} />
          <Route path="/kamen/tlaki" element={<Tlaki />} />
          
          {/* Pulti subpages */}
          <Route path="/pulti/abk-stone-pulti" element={<AbkStonePulti />} />
          <Route path="/pulti/granit-pulti" element={<GranitPulti />} />
          <Route path="/pulti/quartz-pulti" element={<QuartzPulti />} />
          
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;